import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { LINK_HELP_HUBSPOT_INTEGRATE_WITH_TWILIO } from 'shared/constants/links'
import { InputPassword } from 'shared/ui/TextField/InputPresets/InputPassword'
import { type IntegrationTwilioSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationTwilioSettings/store/IntegrationTwilioSettingsStore'
import styles from './styles.module.scss'

type IChangeTwilioCredentialModalContentProps = {
  store: IntegrationTwilioSettingsStore
}

export const ChangeTwilioCredentialModalContent = observer(
  ({ store }: IChangeTwilioCredentialModalContentProps) => {
    const {
      keyLabel,
      secretLabel,
      keyEditValue,
      secretEditValue,
      setKeyEditValue,
      setSecretEditValue,
      apiError,
      saving,
    } = store

    const errorMessage = apiError

    return (
      <div className={styles.wrap}>
        <div>
          <Alert
            item={{
              type: 'infoBlue',
              desc: `Find your ${keyLabel} and ${secretLabel} in the Twilio Admin Console`,
            }}
            rightActions={[
              {
                variant: 'link',
                type: 'primary',
                text: 'Learn more',
                link: LINK_HELP_HUBSPOT_INTEGRATE_WITH_TWILIO,
              },
            ]}
          />
          {errorMessage && (
            <Alert
              marginTop={'8px'}
              item={{
                type: 'error',
                desc: errorMessage,
              }}
            />
          )}
        </div>
        <div className={styles.inputWrap}>
          <Label label={{ text: keyLabel }} />
          <TextField
            variant={'stroke'}
            size={'medium'}
            value={keyEditValue}
            disabled={saving}
            onChange={setKeyEditValue}
            mainActions={[makeTextFieldAutoFocus({ withFocus: true })]}
          />
        </div>
        <div className={styles.inputWrap}>
          <Label label={{ text: secretLabel }} />
          <TextField
            Input={InputPassword}
            variant={'stroke'}
            size={'medium'}
            value={secretEditValue}
            disabled={saving}
            onChange={setSecretEditValue}
            InputProps={{
              placeholder: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
            }}
          />
        </div>
      </div>
    )
  }
)
